import {
  Box,
  Button,
  CircularProgress,
  Container,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import barekamOnlineLogo from "assets/barekam-online-logo.svg";
import barekamPostLogo from "assets/barekam-post-logo.svg";
import boxOpening from "assets/box-opening.mp4";
import courierVideo from "assets/courier.mp4";
import search from "assets/icons/searchIcon.png";
import mobileBackground from "assets/mobile-background.jpg";
import { SettingsContext } from "context/Settings.context";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SERVICES from "services";
import AddOrderDialog from "./components/AddOrderDialog";
import OrderDetailsDialog from "./components/OrderDetailsDialog";
const useStyles = makeStyles((theme) => ({
  bannerCard2: {
    zIndex: 2,
    boxSizing: "border-box",
    padding: "57px 25px",
    width: 415,
    height: 495,
    position: "absolute",
    top: "50%",
    left: "65px",
    transform: "translateY(-50%)",
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(237, 255, 231, 0.16) 100%)",
    backdropFilter: "blur(10px)",
    borderRadius: 20,
    transition: "0.5s",
    "@media (min-width:1020px)": {
      "&:hover": {
        width: 559,
        height: 565,
      },
      "&:hover $cardLogo img": {
        width: 320,
      },
      "&:hover $unhideOnHover": {
        opacity: 1,
        display: "initial",
      },
      "&:hover $hideOnHover": {
        opacity: 0,
        display: "none",
      },
    },
  },
  bannerCard: {
    zIndex: 2,
    boxSizing: "border-box",
    padding: "57px 25px",
    width: 415,
    height: 495,
    position: "absolute",
    top: "50%",
    right: "65px",
    transform: "translateY(-50%)",
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(237, 255, 231, 0.16) 100%)",
    backdropFilter: "blur(10px)",
    borderRadius: 20,
    transition: "0.5s",
    "@media (min-width:1020px)": {
      "&:hover": {
        width: 559,
        height: 565,
      },

      "&:hover $cardLogo img": {
        width: 320,
      },
      "&:hover $unhideOnHover": {
        opacity: 1,
        display: "initial",
      },
      "&:hover $hideOnHover": {
        opacity: 0,
        display: "none",
      },
    },
  },
  orderBtn: { position: "relative", zIndex: 22 },
  [theme.breakpoints.down("1020")]: {
    container: {
      background: `url(${mobileBackground})`,
      backgroundSize: "cover",
    },
    backgroundVideo: {
      display: "none",
    },
    bannerCard: { position: "initial", transform: "initial", maxWidth: 340 },
    bannerCard2: { position: "initial", transform: "initial", maxWidth: 340 },
    cardTitleBlockContainer: {
      marginBottom: "30px !important",
    },
    boxContainer: {
      gap: 32,
      padding: "20px 0",
      display: "flex",
      height: "initial !important",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
  },
  unhideOnHover: {
    transition: ".2s",
    opacity: 0,
    position: "relative",
    overflow: "hiiden",
    whiteSpace: "nowrap",
    width: "100%",
    zIndex: 1,
    height: "0",
  },
  hideOnHover: {
    transition: ".2s",

    opacity: 1,
    display: "initial",
  },
  cardLogo: {
    marginBottom: 34,
    "& img": {
      width: 130,
      transition: "0.5s",
    },
  },
  cardTitleBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  cardTitleBlockContainer: {
    marginBottom: 60,
  },

  cardMainTitle: {
    fontWeight: 700,
    fontSize: 40,
    margin: "0 auto",
    // marginBottom: 90,
    maxWidth: "255px",
    lineHeight: "48px",
  },
  cardSubTitle: {
    "& p": {
      margin: "0!important",
    },
    fontWeight: 400,
    fontSize: "16px",
    textAlign: "left",
  },

  overImage: {
    display: "flex",
    flexDirection: "column",
    padding: "100px 0px",
    [theme.breakpoints.down("md")]: {
      padding: "85px 0px",
    },
  },

  header: {
    textAlign: "left",
    color: "#fff",
    fontStyle: "italic",
    fontWeight: 700,
    fontSize: 38,
    width: "100%",
    lineHeight: 1.5,
    paddingBottom: 10,
    maxWidth: 700,
    [theme.breakpoints.down("md")]: {
      fontSize: 28,
    },
  },
  p: {
    width: 490,
    fontSize: 20,
    textAlign: "left",
    color: "#fff",
    paddingBottom: 35,
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
    },
  },
  addBtn: {
    maxWidth: 195,
    "&.MuiButtonBase-root": {
      textTransform: "unset",
      background: theme.palette.primary.main,
      color: "white",
      borderRadius: 12,
      fontWeight: 700,
      fontSize: 16,
      padding: "5px 30px",
      "&:hover": {
        background: theme.palette.primary.main,
      },
    },
    [theme.breakpoints.down(400)]: {
      maxWidth: "unset",
      width: "100%",
      padding: "5px 20px",
    },
  },
  orderBlock: {
    display: "flex",
    flexDirection: "column",
    margin: "70px auto",
    [theme.breakpoints.down("md")]: {
      margin: "30px 15px",
    },
  },
  trackTitle: {
    display: "flex",
    fontWeight: 600,
    fontSize: 40,
    color: theme.palette.primary.main,
    [theme.breakpoints.down(1042)]: {
      fontSize: 24,
      display: "flex",
      justifyContent: "left",
      alignItems: "left",
      textAlign: "left",
    },
    // [theme.breakpoints.down("xs")]: {
    //   fontSize: 24,
    //   width:300
    // },
  },
  trackOrder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
    width: "100%",
    maxWidth: 1440,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  flexx: {
    display: "flex",
    width: "100%",
    [theme.breakpoints.down(1042)]: {
      flexDirection: "column",
    },
  },
  left: {
    width: "100%",
    backgroundColor: "#fff",
    // maxWidth: 496,
    textAlign: "left",
    // marginBottom: 20,
    // marginTop: 10,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      paddingBottom: 15,
    },
  },
  right: {
    width: "100%",
    maxWidth: 500,
    textAlign: "left",
    display: "flex",
    justifyContent: "end",
    marginTop: 20,
    [theme.breakpoints.down(1042)]: {
      textAlign: "left",
      justifyContent: "left",
      width: "100%",
      maxWidth: 900,
    },
  },
  rights: {
    width: "100%",
    maxWidth: 500,
    textAlign: "left",
    display: "flex",
    justifyContent: "end",
    marginTop: 20,
    [theme.breakpoints.down(1042)]: {
      textAlign: "left",
      justifyContent: "right",
      width: "100%",
      maxWidth: 900,
    },
  },
  searchInput: {
    background: "#FFFFFF",
    width: "100%",
    maxWidth: 500,
    height: 58,
    fontSize: 18,
    position: "relative",
    "& .MuiInputBase-root": {
      borderRadius: 12,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#13A800",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down(1042)]: {
      width: "100%",
      maxWidth: 900,
    },
  },
  trackInput: {
    "&.MuiButtonBase-root": {
      width: 180,
      height: 55,
      zIndex: 5,
      position: "absolute",
      textTransform: "unset",
      backgroundColor: "#13A800",
      color: "white",
      borderRadius: 12,
      fontWeight: 700,
      fontSize: 16,
      padding: "5px 30px",
      "&:hover": {
        background: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        pointerEvents: "auto",
        cursor: "not-allowed",
        opacity: 0.7,
      },
      [theme.breakpoints.down("md")]: {
        width: "unset",
      },
    },
  },
  track: {
    fontWeight: 500,
    fontSize: 20,
    color: "#fff",
  },
  textdiv: {
    display: "flex",
    width: "100%",
    maxWidth: 500,
    textAlign: "left",
    [theme.breakpoints.down(1042)]: {
      textAlign: "left",
      justifyContent: "left",
      width: "100%",
      maxWidth: 900,
    },
  },
  searchBtn: {
    "&.MuiButtonBase-root": {
      textTransform: "unset",
      background: theme.palette.primary.main,
      color: "white",
      borderRadius: 12,
      fontWeight: 400,
      fontSize: 18,
      height: 58,
      padding: "5px 30px",
      margin: "0px 30px",
      "&:hover": {
        background: theme.palette.primary.main,
      },
    },
  },
}));
const Main = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { dispatch } = useContext(SettingsContext);
  const [openOrderDialog, setOpenOrderDialog] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [trackInfo, setTrackInfo] = useState({
    trackNumber: "",
    trackStatuses: [],
    trackStatus: {},
  });
  const { trackNumber } = useParams();

  const handleClick = () => {
    getTrackStatuses(trackInfo.trackNumber);
  };

  const getTrackStatuses = useCallback(
    (trackNum) => {
      setSubmitLoading(true);
      let trackStatuses;
      SERVICES.ACTIONS.getTrackStatuses().then((res) => {
        trackStatuses = res.data;
        SERVICES.ACTIONS.getTrackStatus({
          track_number: trackNum,
        })
          .then((res) => {
            setTrackInfo((prev) => ({
              ...prev,
              trackStatus: res.data,
              trackStatuses,
            }));
          })
          .catch((err) =>
            dispatch({
              type: "ERROR_TOAST",
              payload: { message: err.message },
            })
          )
          .finally(() => setSubmitLoading(false));
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (trackNumber) {
      getTrackStatuses(trackNumber);
      setTrackInfo({ trackNumber });
    }
  }, [trackNumber, getTrackStatuses]);
  // const qrImage = i18next.language === "hy" ? QR2 : QR1;
  return (
    <>
      <div className={classes.container} id="home">
        <Box
          className={classes.boxContainer}
          sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
          }}
        >
          <Box sx={{ flex: 1, overflow: "hidden", position: "relative" }}>
            <video
              className={classes.backgroundVideo}
              src={courierVideo}
              autoPlay
              loop
              muted
              playsInline
              style={{
                zIndex: 1,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "relative",
                objectPosition: "center center",
              }}
            />
            <div className={classes.bannerCard}>
              <div className={classes.cardLogo}>
                <img src={barekamPostLogo} alt="barekam-post-logo" />
              </div>
              <div className={classes.cardTitleBlock}>
                <div className={classes.cardTitleBlockContainer}>
                  <div
                    className={classes.cardMainTitle}
                    style={{ marginBottom: 85 }}
                  >
                    {t("main.firstCard.mainTitle")}
                  </div>
                  <div className={classes.cardSubTitle}>
                    <div>
                      <p>{t("main.firstCard.secondTitle1")}</p>
                      <p>{t("main.firstCard.secondTitle2")}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <Button
                    disableRipple
                    onClick={() => setOpenOrderDialog(!openOrderDialog)}
                    className={classes.orderBtn}
                    sx={{
                      width: 220,
                      height: 48,
                      backgroundColor: "#087E38",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#D51838",
                      },
                    }}
                  >
                    {t("main.firstCard.orderBtn")}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
          <Box sx={{ flex: 1, overflow: "hidden", position: "relative" }}>
            <video
              className={classes.backgroundVideo}
              src={boxOpening}
              autoPlay
              loop
              muted
              playsInline
              style={{
                zIndex: 1,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "relative",
                objectPosition: "center center",
              }}
            />
            <div className={classes.bannerCard2}>
              <div className={classes.cardLogo}>
                <img src={barekamOnlineLogo} alt="barekam-online-logo" />
              </div>
              <div className={classes.cardTitleBlock}>
                <div className={classes.cardTitleBlockContainer}>
                  <div
                    className={classes.cardMainTitle}
                    style={{ marginBottom: 34 }}
                  >
                    {t("main.secondCard.mainTitle")}
                  </div>
                  <div className={classes.cardSubTitle}>
                    <div>
                      <p>{t("main.secondCard.secondTitle1")}</p>
                      <p>{t("main.secondCard.secondTitle2")}</p>
                    </div>
                  </div>
                </div>
                <div>
                  <Button
                    disableRipple
                    onClick={() =>
                      window.open("https://online.barekam.am/hy", "_blank")
                    }
                    className={classes.orderBtn}
                    sx={{
                      width: 220,
                      height: 48,
                      backgroundColor: "#087E38",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#D51838",
                      },
                    }}
                  >
                    {t("main.secondCard.orderBtn")}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </Box>
      </div>
      <Container maxWidth={"xl"} className={classes.orderBlock}>
        <div className={classes.flexx}>
          <div className={classes.left}>
            {/* <img
              src={qrImage}
              alt="/"
              style={{ width: "100%", maxWidth: 450, height: 130 }}
            /> */}
            <div className={classes.textdiv}>
              <span className={classes.trackTitle}>
                {t("main.trackCourierTitle")}
              </span>
            </div>
            <div className={classes.right} style={{ marginBottom: 10 }}>
              <span>{t("main.trackCourierText")}</span>
            </div>
          </div>
          <div className={classes.trackOrder}>
            <div className={classes.rights}>
              <TextField
                id="outlined-basic"
                value={trackInfo?.trackNumber || ""}
                placeholder={"AMPL0000000"}
                className={classes.searchInput}
                disabled={submitLoading}
                onChange={(event) => {
                  setTrackInfo((prev) => ({
                    ...prev,
                    trackNumber: event.target.value,
                  }));
                }}
              />
              <Button
                className={classes.trackInput}
                onClick={handleClick}
                disabled={!trackInfo?.trackNumber || submitLoading}
              >
                {submitLoading ? (
                  <CircularProgress size={30} color={"secondary"} />
                ) : (
                  <>
                    <img src={search} alt="search_icon" />
                    {!isMobile && (
                      <span className={classes.track}>{t("main.track")}</span>
                    )}
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </Container>
      <AddOrderDialog open={openOrderDialog} setOpen={setOpenOrderDialog} />
      <OrderDetailsDialog
        open={
          !!(
            trackInfo.trackNumber &&
            trackInfo?.trackStatus?.length &&
            trackInfo.trackStatuses?.length
          )
        }
        setOpen={setTrackInfo}
        trackInfo={trackInfo}
      />
    </>
  );
};

export default Main;
